<template>
	<div ref="self" class="l-row list-wrap">
		<div class="g-row">
			<div class="work-list i-work-list" :class="{'work-list--no-filter': filter == false }">
				<div class="work-list__item">
					<WorkFilter v-if="filter"/>
				</div>
				<div
					class="work-list__item"
					v-for="(item, index) in data.list"
					:key="generateKey(index)"
				>
					<Minime
						v-if="item.type == 'minime'"
						:desc="item.align == 'left' ? 'We understand both the brand and the customer. And we’re good at finding that sweet spot that brings the two together.' : 'We see things differently because every day is a new day and no two brands are the same.'"
						:desc-side="item.align == 'left' ? 'centerLeft' : 'right'"
						balloon=""
						:is-balloon-right="item.align == 'left' ? true : false"
					/>
					<div v-else-if="item.type == 'blank'"></div>
					<WorkUnit v-else :item="item" :lazy="true"></WorkUnit>
				</div>
			</div>
		</div>
	</div>
	<div v-if="data.archiveList.length > 0" class="l-full">
		<MarqueeText class="archive-marquee">
			<template v-slot:default>
				<span class="archive-marquee__txt">
					<span class="c-marquee__txt t-h--128 t-h--200l t-h--54s">
						<span class="t--fak">ARCHIVE</span>
					</span>
					<Minime
						:balloon="data.minimeText"
						:is-block-content="true"
						balloon-color="brown"
						class="archive-marquee__minime"
						:frame-number="data.marqueeMinimeNumer1"
					/>
				</span>
				<span class="archive-marquee__txt">
					<span class="c-marquee__txt t-h--128 t-h--200l t-h--54s">
						<span class="t--fak">OLD & NEW</span>
					</span>
					<Minime
						:is-block-content="true"
						class="archive-marquee__minime"
						:frame-number="data.marqueeMinimeNumer2"
					/>
				</span>
			</template>
		</MarqueeText>
	</div>
	<div v-if="data.archiveList.length > 0" class="l-row archive">
		<div class="g-row s--h-start">
			<div
				class="archive__item"
				v-for="(item, index) in data.archiveList"
				:key="generateKey(index)"
			>
				<WorkUnit :item="item" :lazy="true" layoutType="archive"></WorkUnit>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "fxjs";
import * as $ from 'fxdom';
import { ref, reactive, watch, useStore, computed, onMounted, onUnmounted } from "@/helper/vue.js";
import Minime from "@/parts/minime/Minime.vue";
import MarqueeText from "@/parts/MarqueeText.vue";
import WorkUnit from "@/pages/work/WorkUnit.vue";
import WorkFilter from "@/pages/work/WorkFilter2.vue";

import { allArr, getWork, categoryArr, themeArr } from '@/store/data-workList.js';
import { generateKey } from "@/helper/gadget.js";
import { TextType } from "@/parts/minime/data-minime-type.js"

export default {
	props: [ "filter" ],
	components: {
    Minime,
		MarqueeText,
    WorkUnit,
    WorkFilter,
  },
	setup(props) {
		const { state, commit, dispatch } = useStore();
		const self = ref();
		const data = reactive({
			minimeText: "",
			marqueeMinimeNumer1: 0,
			marqueeMinimeNumer2: 0,
			separateCount: computed(() => {
        if(state.cw > 1599) {
          return 9;
        }
				else if(state.cw > 599) {
          return 8;
        }
        else {
          return 8;
        }
      }),
			getLimit: computed(() => {
        if(state.cw > 1599) {
          return 28;
        }
        else if(state.cw > 599) {
          return 25;
        }
        else {
          return 25;
        }
      }),
			list: computed(() => {
				let newList;
        if(state.workList.selectedCategory != -1) {
					// list = [...getWork(categoryArr[state.workList.selectedCategory])];
					newList = getWork(categoryArr[state.workList.selectedCategory]);
        }
        else if(state.workList.selectedTag != -1) {
					// list = [...getWork(themeArr[state.workList.selectedTag])];
					newList = getWork(themeArr[state.workList.selectedTag]);
        }
        else {
          // list = [...allArr];
					newList = _.take(data.getLimit, allArr);
        }

				// 필터가 off이면 css 순서를 맞춰주기 위해서 빈 오브젝트를 하나 넣어준다.
				!props.filter && newList.unshift({ type: "blank" });

        // 미니미가 들어갈 수 있는 갯수가 아니면 그대로 리턴
        if(newList.length < data.separateCount + 2) {
          return newList;
        }
        else {
          let odd = false;
          _.go(
            _.range(Math.floor((newList.length - 2) / data.separateCount)),
            _.each(n => {
              newList = _.insert(data.separateCount * (n + 1) + n + 1, { type: "minime", align: ( odd = !odd) ? "left" : "right" }, newList);
            })
          );
          return newList;
        }
      }),
			archiveList: computed(() => {
				if(state.workList.selectedCategory == -1 && state.workList.selectedTag == -1) {
					let a = 0;
					const newList = [];
					_.go(
						_.range(allArr.length),
						_.each(index => {
							if(index > data.getLimit - 1) {
								newList.push(allArr[index]);
							}
						})
					);
					// newList.splice(0, data.getLimit);
					return newList;
				}
				else {
					return [];
				}
			})
		});

		const txtIndex = state.minimeTxtRemain[Math.floor(Math.random() * state.minimeTxtRemain.length)];
    commit('checkMinimeTxtRemain', { selected: txtIndex, init: false });
		data.minimeText = TextType[txtIndex];

		data.marqueeMinimeNumer1 = state.minimeRemain[Math.floor(Math.random() * state.minimeRemain.length)];
		commit('checkMinimeRemain', { selected: data.marqueeMinimeNumer1, init: false });
		data.marqueeMinimeNumer2 = state.minimeRemain[Math.floor(Math.random() * state.minimeRemain.length)];
		commit('checkMinimeRemain', { selected: data.marqueeMinimeNumer2, init: false });

		onMounted(() => {
			watch(
				() => data.list,
				() => {
					setTimeout(() => {
						dispatch('onChangeDom');
					});
				}
			);
			// $.qs(".test", self.value).addEventListener("click", () => {
			// 	alert(1);
			// });
		});

		return {
			self,
			data,
			generateKey,
		}

	}
}
</script>

<style scoped lang="scss">

.list-wrap {
	width: 100%;
}

.work-list {
	display: flex;
	margin-top: 36em;
	min-height: 100vh;
	width: 100%;
	justify-content: flex-start;
	flex-wrap: wrap;
	overflow: hidden;
	.__w600 & {
		margin-top: 32em;
	}
	&__item {
		flex-shrink: 0;
    flex-grow: 0;
    margin-left: var(--gut);
    margin-right: var(--gut);
    margin-top: 128em;
    max-width: 100%;
		flex-basis: var(--cw6);
		&:nth-child(1) {
			flex-basis: var(--cw5);
      margin-top: 21em;
		}
		&:nth-child(2) {
			flex-basis: var(--cw9);
			margin-left: calc(var(--cw1) + var(--gutter) * 1.5);
      margin-top: 0;
		}
		&:nth-child(9n + 4) {
			margin-right: calc(var(--cw3) + var(--gutter) * 1.5);
		}
		&:nth-child(9n + 6), &:nth-child(9n + 7), &:nth-child(9n + 10) {
			margin-left: calc(var(--cw3) + var(--gutter) * 1.5);
		}
    // 미니미
		&:nth-child(9n + 11) {
			flex-basis: var(--cw15);
      margin-top: 0;
      margin-bottom: -96em;
		}
    .w1600__ & {
      margin-left: var(--gut);
      margin-right: var(--gut);
      margin-top: 256em;
      margin-bottom: 0;
      flex-basis: var(--cw5);
      &:nth-child(1) {
        flex-basis: var(--cw5);
        margin-top: 21em;
      }
      &:nth-child(2) {
        flex-basis: var(--cw9);
        margin-left: calc(var(--cw1) + var(--gutter) * 1.5);
        margin-top: 0;
      }
      &:nth-child(10n + 5) {
        flex-basis: var(--cw3);
        margin-left: calc(var(--cw2) + var(--gutter) * 1.5);
      }
      &:nth-child(10n + 6) {
        flex-basis: var(--cw3);
        margin-right: calc(var(--cw2) + var(--gutter) * 1.5);
      }
      &:nth-child(10n + 10) {
        flex-basis: var(--cw3);
        margin-left: calc(var(--cw1) + var(--gutter) * 1.5);
        margin-right: calc(var(--cw1) + var(--gutter) * 1.5);
      }
      // 미니미
      &:nth-child(10n + 12) {
        flex-basis: var(--cw15);
        margin-top: 0;
        margin-bottom: -224em;
      }
    }
    .__w600 & {
			flex-basis: var(--cw5);
			margin-left: var(--gut);
      margin-right: var(--gut);
			&:nth-child(1) {
        display: none;
      }
		}
	}
	&--no-filter {
		.work-list__item:nth-child(1), .work-list__item:nth-child(2) {
			display: none;
		}
	}
}

.archive-marquee {
  padding-top: 128em;
  margin-top: 128em;
  &__minime {
    display: flex;
    align-items: flex-end;
  }
  .__w600 & {
    padding-bottom: 18em;
		margin-bottom: -18em;
  }
  &__txt {
    position: relative;
    display: flex;
    :deep(.minime) {
      margin-top: -20em;
      .minime__wrap {
        .__w600 & {
          width: 48em;
        }
      }
      .w1600__ & {
        margin-top: 0
      }
    }
    .__w600 & {
      align-items: center;
    }
  }
}

.archive {
	// display: flex;
	// flex-wrap: wrap;
	&__item {
		flex-shrink: 0;
    flex-grow: 0;
    margin-left: var(--gut);
    margin-right: var(--gut);
		margin-top: 64em;
		flex-basis: var(--cw3);
		&:nth-child(12n + 4), &:nth-child(12n + 7), &:nth-child(12n + 10) {
			margin-left: calc(var(--cw3) + var(--gutter) * 1.5);
		}
		.__w600 & {
			flex-basis: var(--cw2);
			margin-left: var(--gut);
    	margin-right: var(--gut);
			&:nth-child(8n + 1), &:nth-child(8n + 6) {
				flex-basis: var(--cw3);
			}
			&:nth-child(8n), &:nth-child(8n + 4) {
				margin-left: calc(var(--cw1) + var(--gutter) * 1.5);
			}
		}
	}
}
</style>